export const validateSiren = (value?: string): boolean => {
  if (!value) return false;
  return /^\d{9}$/.test(value.replace(/ /g, ''));
};

export const validateOptionalSiren = (value?: string): boolean => {
  if (!value) return true;

  return validateSiren(value);
};
